import { useStatsSectionStyles } from "./styles";

import ratingIcon from "../../../../assets/images/mentor_profile/rating.png";
import sandglassIcon from "../../../../assets/images/mentor_profile/sandglass.png";
import videoCallIcon from "../../../../assets/images/mentor_profile/video_call.png";
import pupilIcon from "../../../../assets/images/mentor_profile/pupil.png";
import cyRating from "../../../../assets/images/cy-rating.png";

const formatValue = (val, suffix = "", shouldRound = false) => {
  if (val === null || val === undefined) return "—";
  const formattedVal = shouldRound ? Math.round(val) : val;
  return `${formattedVal}${suffix}`;
};

export const StatsSection = ({ profileData = {} }) => {
  const classes = useStatsSectionStyles();

  const {
    overallRating,
    experienceWithCodeyoung,
    totalClasses,
    totalStudents,
    ratings
  } = profileData;

  const statsData = [
    {
      icon: ratingIcon,
      value: formatValue(overallRating),
      label: "rated by happy parents",
      highlight: true,
    },
    {
      icon: sandglassIcon,
      value: formatValue(experienceWithCodeyoung, " years", true),
      label: "teaching with Codeyoung",
      highlight: false,
    },
    {
      icon: videoCallIcon,
      value: formatValue(totalClasses),
      label: "live classes taken",
      highlight: false,
    },
    {
      icon: pupilIcon,
      value: formatValue(totalStudents),
      label: "students nurtured",
      highlight: false,
    },
    {
      icon: cyRating,
      value: formatValue(ratings),
      label: "Codeyoung rating",
      highlight: false,
    },
  ];

  return (
    <div className={classes.statsWrapper}>
      <div className={classes.statsGrid}>
        {statsData.map((stat, index) => (
          <div key={stat.label} style={{ display: "contents" }}>
            {index > 0 && <div className={classes.statDivider} />}
            <div className={classes.statCard}>
              <div className={classes.statContent}>
                <img
                  src={stat.icon}
                  alt={stat.label}
                  className={classes.statIcon}
                />

                <div
                  className={classes.statValue}
                  style={{ color: stat.highlight ? "#3333FF" : "#404040" }}
                >
                  {stat.value}
                </div>
              </div>
              <div className={classes.statLabel}>{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
